import { useState } from 'react';
import { Button } from '../../../../ui/General/Button/Button.tsx';
import { Icon } from '../../../../ui/General/Icon/Icon.tsx';
import { PickupPointModal } from '../../../../widgets/Delivery/components/PickupPointModal/PickupPointModal.tsx';

interface Props {
    currentCity: string;
    branchId: number;
    townId: number;
}

/**
 * Блок "Доставка транспортной компанией"
 * @returns 
 */
export const ProductSearchByTransitionCompany: React.FC<Props> = ({currentCity, branchId, townId}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className='flex flex-col justify-center'>
            <h4 className='text-xl font-bold mb-2 mt-8 text-[#f39200]'>Найти с доставкой транспортной компанией</h4>
            <Button onClick={() => setIsOpen(true)}><Icon name='search' width={18} height={18} color='#fff'></Icon>Найти</Button>
            {isOpen && <PickupPointModal
                    isOpen={isOpen}
                    close={() => setIsOpen(false)}
                    open={() => setIsOpen(true)}
                    currentBranchAddress={currentCity}
                    currentBranchId={branchId}
                    currentTownId={townId}
                    forCart={false}
                />}
        </div>
    );
};